import styled from "styled-components";

export const WarningMessage = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const StatsPerformPanel = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const StatsPerformPanelLogo = styled.img`
  width: 60px;
`;

export const StatsPerformText = styled.div`
  font-size: 10px;
`;

export const UnLicensedMessage = styled.div`
  font-size: 14px;
  padding: 20px;
  background-color: ${({ theme }) => theme.white};
  margin-bottom: 5px;
`;
